import React from 'react';
export default class MoreButton extends React.Component {
  render() {
    return (
      <span className="MoreButton fader">
        <span>MORE</span>
      </span>
    )
  }
}